module.exports = {
    PERMISSIONS: {
        ANDROID: {
            READ_EXTERNAL_STORAGE: 'android.permission.READ_EXTERNAL_STORAGE',
            WRITE_EXTERNAL_STORAGE: 'android.permission.WRITE_EXTERNAL_STORAGE',
        },
        IOS: {
            PHOTO_LIBRARY: 'ios.permission.PHOTO_LIBRARY',
        },
    },
    RESULTS: {
        UNAVAILABLE: 'unavailable',
        DENIED: 'denied',
        LIMITED: 'limited',
        GRANTED: 'granted',
        BLOCKED: 'blocked',
    },
    openSettings: () => { },
    check: () => { },
    request: () => { },
};
